<template>
  <div>
    <rabbey-toolbox>
      <div class="mr-5 box">
        <el-select
          v-model="serviceTypeID"
          @change="handlerChangesServices"
          size="mini"
          clearable
          placeholder="Tipo de servicio"
          class="ml-5"
          filterable
        >
          <el-option
            v-for="item in serviceTypeList"
            :key="item.Id"
            :label="item.Description"
            :value="item.Id"
          >
          </el-option>
        </el-select>
        <yearcomponent
          ref="yearC"
          @change="handler_year"
          v-model="year"
        ></yearcomponent>
      </div>
      <div class="mr-5 box">
        <el-select
          v-loading="loading"
          v-model="employeeId"
          filterable
          clearable
          size="mini"
          placeholder="Colaborador"
          @change="handleChangeEmployee"
        >
          <el-option
            v-for="item in employees"
            :key="item.EmployeeID"
            :label="item.Name"
            :value="item.EmployeeID"
          >
          </el-option>
        </el-select>
      </div>

      <div class="mr-5 box">
        <el-select
          v-loading="loading"
          v-model="deparmentId"
          filterable
          clearable
          size="mini"
          placeholder="Departamento"
          @change="handleChangeDeparment"
        >
          <el-option
            v-for="(item, index) in deparments"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="mr-5 box">
        <el-select
          v-loading="loading"
          v-model="directionIdFilter"
          filterable
          clearable
          size="mini"
          placeholder="Direccion"
          @change="handleChangeDirection"
        >
          <el-option
            v-for="(item, index) in directions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </rabbey-toolbox>
    <!-- table principal -->

    <el-row>
      <el-col>
        <!-- <rabbey-table2
          :columns="columns2"
          :show-summary="true"
          :summary-method="getTotalByMonthSLA"
          :default-items="technicalTracker"
          :paginateFromApi="false"
          v-loading="principalTable"
        /> -->
        <rabbey-table-3
          show-summary
          v-loading="principalTable"
          :columns="columns2"
          :data="technicalTracker"
          :summary-method="getTotalByMonthSLA"
        />
      </el-col>
    </el-row>

    <!-- table detalle por Vendedor -->
    <DetailTechnicalSupportKpi ref="details" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import {
  MonthsRabbey3,
  commentColumns
} from "@/helpers/TechnicalSupportColumns";
import { getTotalByMonthSLA } from "@/helpers/TableRabbeyTools";
import DetailTechnicalSupportKpi from "./DetailTechnicalSupportKpi.vue";
import { formatArrayToElSelect } from "@/utils";
// import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";

export default {
  name: "KpiSoporteTecnico",
  components: { DetailTechnicalSupportKpi, yearcomponent },
  data() {
    return {
      deparmentId: "",
      employeeId: "",
      serviceTypeID: "",
      directionIdFilter: "",

      directionId: 0,
      serviceTypeList: [],
      loading: false,
      deparments: [],
      directions: [],
      employees: [],
      principalTable: true,
      loadingDetails: true,
      deals: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",
      TypeAgent: "customerservice",
      typeServices: [],
      types: [
        { value: 0, label: "Todos los Productos" },
        { value: 2, label: "MagyTrack" },
        { value: 14, label: "TPD" },
        { value: 15, label: "NCF Movil" },
        { value: 16, label: "SeaHorse" },
        { value: 17, label: "MagyPago" },
        { value: 18, label: "Magylottery" }
      ],
      SellerName: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      MontlyTarget: "",
      AccountNumber: "",
      product: 0,
      InvoiceNum: "",
      ContactEmail: "",
      ProductList: [],
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },
      columns: [
        {
          prop: "tecnico",
          name: "Tecnico",
          minWidth: 220,
          fixed: true
        }
        //...Months
      ],
      columns2: [
        {
          prop: "technical",
          label: "Tecnico",
          minWidth: 220,
          fixed: true,
          formatter: ImagePerson,
          attrs: {
            imgKey: "TechPhoto"
          }
        },
        ...this.mapOb(MonthsRabbey3)
      ],
      columnsComments: [...commentColumns],
      items: [],
      comments: [],
      Dcoments: false,
      commentloading: false,
      slaTracker: {
        Failed: 0,
        Compliment: 1
      },
      technicalTracker: []
    };
  },
  mounted() {
    this.$refs.yearC.Year = this.year;
  },
  created() {
    this.getEmployees();
    this.getDepartaments();
    this.getDirections();
    this.getData();
    this.$store.dispatch("request_types/internal");
    this.$store.dispatch("products/all");

    this.$http
      .get("/api/KpiTechnicalSupport/getTypeServicesSLA", {
        params: { companyId: this.currentCompany }
      })
      .then(({ data }) => {
        this.typeServices = this.formatArrayToElSelect(data, {
          value: "Id",
          label: "Description"
        });
        this.typeServices.unshift({ value: 0, label: "Todos los Servicios" });
      });
  },
  watch: {
    list_products() {
      this.list_products.unshift({ value: 0, label: "Todos los Productos" });
    },
    list_types_to_select() {
      this.list_types_to_select.unshift({
        value: 0,
        label: "Todos los Servicios"
      });
    }
  },
  computed: {
    ...mapGetters({
      list_types_to_select: "request_types/list_to_select",
      list_products: "products/list_products"
    }),
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    },
    groupItems() {
      return this._.groupBy(this.items, "tecnico");
    }
  },
  methods: {
    getTotalByMonthSLA,
    formatArrayToElSelect,
    getPorcentajeByUserAndMonth(month, techinicalName, year) {
      const KpiTechnicalSupport = this.groupItems[techinicalName];
      if (KpiTechnicalSupport === undefined) {
        return 0;
      }

      let countCompliment = 0;
      let countFailed = 0;
      for (let index = 0; index < KpiTechnicalSupport.length; index++) {
        const element = KpiTechnicalSupport[index];
        const createdAt = this.$moment(
          element.CreatedAt,
          "YYYY-MM-DDTHH:mm:ss.SSS"
        );
        const elementMonth = createdAt.format("M");
        const elementYear = createdAt.format("YYYY");

        if (
          month === elementMonth &&
          year === elementYear &&
          element.SLA === this.slaTracker.Compliment
        ) {
          countCompliment++;
        }

        if (
          month === elementMonth &&
          year === elementYear &&
          element.SLA === this.slaTracker.Failed
        ) {
          countFailed++;
        }
      }

      const suma = countCompliment + countFailed;
      let Porcentaje = suma > 0 ? (countCompliment / suma) * 100 : 0;

      return Porcentaje;
    },
    openDetail(mes, row) {
      this.$refs.details.show(row, mes, this.year);
    },
    getProductSelected() {
      return this.product;
    },
    getServiceTypeSelected() {
      return this.serviceTypeID;
    },
    mapOb(data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.cellAtrrs = {
          getProductSelected: this.getProductSelected,
          getServiceTypeSelected: this.getServiceTypeSelected,
          openDetail: this.openDetail,
          ...element.cellAtrrs
        };
      }
      return data;
    },
    handler_year(_year) {
      this.year = _year;
      this.getData();
    },
    handlerChangesProduct(_Product) {
      this.product = _Product;
      this.getData();
    },
    handlerChangesServices(_Service) {
      this.serviceTypeID = _Service;
      this.getData();
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
    },
    getData() {
      let params = {
        year: this.year,
        companyID: this.currentCompany,
        product: this.product,
        serviceTypeID: this.serviceTypeID,
        directionId: this.directionId ? this.directionId : 0,
        employeeId: this.employeeId ? this.employeeId : 0,
        deparmentId: this.deparmentId ? this.deparmentId : 0
      };
      this.$store.commit("rabbey_table/loading");
      this.$http
        .get("/api/KpiTechnicalSupport/GetKpiSupportInternal", {
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.$store.commit("rabbey_table/items", data);
          const technicalsGroup = this._.groupBy(data, "tecnico");
          const TechPhotoGroup = this._.groupBy(data, "TechPhoto");

          let t = {};
          this.technicalTracker = [];
          const technicals = Object.keys(technicalsGroup);
          const TechPhotos = Object.keys(TechPhotoGroup);

          for (let index = 0; index < technicals.length; index++) {
            const techinicalName = technicals[index];
            const TechPhoto = TechPhotos[index];

            t = {
              technicalId: 0,
              technical: techinicalName,
              1: 0,
              2: 0,
              3: 0,
              4: 0,
              5: 0,
              6: 0,
              7: 0,
              8: 0,
              9: 0,
              10: 0,
              11: 0,
              12: 0,
              TechPhoto: TechPhoto,
              total: 0
            };

            const solicitudes = technicalsGroup[techinicalName];
            const primeraSolicitud = solicitudes[0];
            const createdAt = this.$moment(
              primeraSolicitud.CreatedAt,
              "YYYY-MM-DDTHH:mm:ss.SSS"
            );
            const year = parseInt(createdAt.format("YYYY"));
            t.technicalId = primeraSolicitud.tecnicoID;
            let monthTracker = {
              1: {
                Compliment: 0,
                Failed: 0
              },
              2: {
                Compliment: 0,
                Failed: 0
              },
              3: {
                Compliment: 0,
                Failed: 0
              },
              4: {
                Compliment: 0,
                Failed: 0
              },
              5: {
                Compliment: 0,
                Failed: 0
              },
              6: {
                Compliment: 0,
                Failed: 0
              },
              7: {
                Compliment: 0,
                Failed: 0
              },
              8: {
                Compliment: 0,
                Failed: 0
              },
              9: {
                Compliment: 0,
                Failed: 0
              },
              10: {
                Compliment: 0,
                Failed: 0
              },
              11: {
                Compliment: 0,
                Failed: 0
              },
              12: {
                Compliment: 0,
                Failed: 0
              }
            };

            for (let index = 0; index < solicitudes.length; index++) {
              const solicitud = solicitudes[index];
              const createdAt = this.$moment(
                solicitud.CreatedAt,
                "YYYY-MM-DDTHH:mm:ss.SSS"
              );
              const elementMonth = parseInt(createdAt.format("M"));
              const elementYear = parseInt(createdAt.format("YYYY"));

              for (let month = 1; month < 13; month++) {
                if (month === elementMonth && year === elementYear) {
                  if (solicitud.SLA === this.slaTracker.Compliment) {
                    monthTracker[month].Compliment++;
                  } else if (solicitud.SLA === this.slaTracker.Failed) {
                    monthTracker[month].Failed++;
                  }
                }
              }
            }

            let c = 0;
            let f = 0;
            for (let month = 1; month < 13; month++) {
              const { Compliment, Failed } = monthTracker[month];
              c += Compliment;
              f += Failed;
              const sum = Compliment + Failed;
              t[`${month}`] = sum > 0 ? (Compliment / sum) * 100 : 0;
            }

            const sumTotal = c + f;
            t.total = sumTotal > 0 ? (c / sumTotal) * 100 : 0;

            this.technicalTracker.push(t);
          }
        })
        .finally(() => {
          this.$store.commit("rabbey_table/success");
          this.principalTable = false;
        });
    },
    getProductbySLA() {
      this.$http
        .get("/api/KpiTechnicalSupport/getProductbySLASupport", {
          params: {
            companyId: this.company
          }
        })
        .then((resp) => {
          this.ProductList = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getTypeServices() {
      this.$http
        .get("/api/KpiTechnicalSupport/getTypeServicesSLA", {
          params: {
            companyId: this.company
          }
        })
        .then((resp) => {
          this.TypeService = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    handleChangeDirection(directionId) {
      this.directionIdFilter = directionId;
      this.directionId = directionId;
      this.getDepartaments();
      this.getData();
      this.getServicesTypes(this.directionId);
    },
    handleChangeDeparment(deparmentId) {
      this.deparmentId = deparmentId;
      this.getEmployees();
      this.getData();
    },
    handleChangeEmployee(employee) {
      this.employeeId = employee;
      this.getData();
    },
    getDirections() {
      this.$http
        .get("/api/Directions/DirectionsByCompany", {
          params: {
            company: this.currentCompany
          }
        })
        .then((response) => {
          this.directions = this.formatArrayToElSelect(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      if (this.directionId > 0) {
        uri = `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${this.directionId}`;
      } else {
        uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;
      }

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },
    getDepartaments() {
      this.directionId = this.directionId == "" ? 0 : this.directionId;
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;
      uri = `/api/Directions/DepartmentByDirecctionIDExt?DirecctionId=${this.directionId}&CompanySelected=${company}&employeeid=${employeeId}`;
      this.$http
        .get(uri)
        .then((response) => {
          this.deparments = this.formatArrayToElSelect(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getServicesTypes(criteria) {
      criteria = criteria == "" ? 0 : criteria;
      this.$http
        .get("/api/serviceRequestTypes/GetServiceByCompany", {
          params: {
            direccionID: criteria != undefined ? criteria : 0
          }
        })
        .then((resp) => {
          this.serviceTypeList = resp.data.filter(
            (f) => f.IsInternal !== null && f.IsInternal
          );
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    }
  }
};
</script>

<style>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
